import React from 'react';
import { useHistory } from 'react-router-dom';

/**
 * Set/Update history's search property.
 * Use it as React hook on the page where you need to set/update history's search property.
 * Example:
 * const MyPage = (props) => {
 *   useUpdateHistorySearch(searchQueryParams);
 *
 *   ... your code here
 *
 *   return (
 *    <div>My Page</div>
 *   );
 * };
 */
export const useUpdateHistorySearch = (searchQueryParams = {}, shouldHistoryPush = false) => {
  const createQueryString = (queryParams) => {
    let query;
    const querySubStringsArray = Object.keys(queryParams).map((param) => {
      if (queryParams[param]) query = `${param}=${encodeURIComponent(queryParams[param])}`;
      return query;
    });
    return querySubStringsArray.join('&');
  };

  const [historyPush, setHistoryPush] = React.useState(shouldHistoryPush);
  const [query, updateQuery] = React.useState(createQueryString(searchQueryParams));
  const [keepState, updateKeepState] = React.useState(true);
  const history = useHistory();

  const setQuery = (newSearchQueryParams, shouldHistoryPush = false, keepState = true) => {
    updateKeepState(keepState);
    setHistoryPush(shouldHistoryPush);
    updateQuery(createQueryString(newSearchQueryParams));
  };

  React.useEffect(() => {
    history[historyPush ? 'push' : 'replace']({
      ...history.location,
      search: query,
      state: keepState ? history.location.state : {},
    });
  }, [query]);
  return [query, setQuery];
};

export default useUpdateHistorySearch;
